import React, { useEffect, useState } from 'react';
import { Save, Pencil, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import { Button } from '../ui/button';
import { GymClassificationEditor } from './GymClassificationEditor';

export const GymSessionEditor = ({ sessionId, prefix = 'linked-gym', canEdit = false }) => {
  const { api } = useAuth();
  const { language } = useLanguage();
  const [session, setSession] = useState(null);
  const [value, setValue] = useState(null);
  const [editing, setEditing] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    api.get(`/sessions/${sessionId}`).then(r => { if (active) { setSession(r.data); setValue(r.data.gym_classification ?? null); } }).catch(() => {});
    return () => { active = false; };
  }, [api, sessionId]);
  if (!session || !['GYM', 'STRENGTH'].includes(session.type)) return null;
  const save = async () => {
    setBusy(true); setError('');
    try {
      const r = await api.put(`/sessions/${sessionId}/gym-classification`, { gym_classification: value });
      setSession({ ...session, gym_classification: r.data.gym_classification });
      setValue(r.data.gym_classification); setEditing(false);
    } catch (e) { setError(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : language === 'IT' ? 'Classificazione non valida.' : 'Invalid classification.'); }
    finally { setBusy(false); }
  };
  return <div className="min-w-0" data-testid={`${prefix}-session`}>
    <GymClassificationEditor value={value} onChange={setValue} duration={session.duration_planned_min} prefix={prefix} readOnly={!editing} />
    {canEdit && <div className="flex flex-wrap gap-2 pt-2">
      {editing ? <><Button type="button" disabled={busy} onClick={save} data-testid={`${prefix}-save`}><Save size={16} className="mr-2" />{language === 'IT' ? 'Salva' : 'Save'}</Button>
        <Button type="button" variant="ghost" disabled={busy} onClick={() => { setValue(session.gym_classification ?? null); setEditing(false); setError(''); }} data-testid={`${prefix}-cancel`}><X size={16} className="mr-2" />{language === 'IT' ? 'Annulla' : 'Cancel'}</Button></>
        : <Button type="button" variant="outline" onClick={() => setEditing(true)} data-testid={`${prefix}-edit`}><Pencil size={16} className="mr-2" />{language === 'IT' ? 'Modifica classificazione' : 'Edit classification'}</Button>}
    </div>}
    {error && <div role="alert" className="text-xs text-rose-400 py-2" data-testid={`${prefix}-save-error`}>{error}</div>}
  </div>;
};